import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, SendDataToApi } from "@insite/client-framework/Store/CommonHandlers/ShareProduct";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { xGoogleAnalyticsState } from "@stoneage/App/Store/Reducers";
import { getDataLayer, trackAsImpersonation } from "@stoneage/App/Utilities/DataLayer";

export const TrackGaShareProduct: typeof SendDataToApi = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (state.xGoogleAnalytics.shareProductEvent) {
        const dataLayer = getDataLayer();
        if (!dataLayer) {
            return;
        }

        const billToState = getBillToState(state, state.context.session?.billToId);
        const customerNumber = billToState?.value?.customerNumber;

        const googleAnalyticsData = {
            event: "pdp_email_share",
            item: props.parameter.product.productTitle,
            user: props.parameter.yourEmailAddress,
            recipient_email: props.parameter.friendsEmailAddress,
            affiliation: customerNumber || "",
            item_id: props.parameter.product.productNumber,
            impersonation: trackAsImpersonation(state),
        };

        dataLayer.push(googleAnalyticsData);
    }
};

addToChainAfter(chain, SendDataToApi, TrackGaShareProduct);
